import { Col, Row, Table } from "reactstrap";
import { useContext, useEffect, useState } from "react";
import { getDeviceConfig, getDeviceId } from "../../api/api";
import Spinner from "../../commons/Spinner";
import { formatValue, idExists } from "../../utils/NumberUtils";
import { useHistory } from "react-router-dom";
import { SchoolContext } from "../../context/SchoolContext";


const Devicepage = () => {

    const { schoolList, setSchool } = useContext(SchoolContext);
    const [pcsData, setpcsData] = useState([]);
    const [loading, setLoading] = useState(false);
    const authToken = localStorage.getItem('accessToken');
    const [deviceId, setDeviceId] = useState(null);
    const history = useHistory();
    const pathname = history["location"].pathname
    const school_id = Number(pathname.split('/').pop());

    useEffect(() => {
        setLoading(true)
        const Value = JSON.parse(localStorage.getItem('schools'));
        const schoolObj = { id: school_id };
        if (Value && Value !== null && Value.some(obj => obj.id === schoolObj.id)) {
            setDeviceId(Value.find(obj => obj.id === schoolObj.id).device_id);
            setSchool(Number(school_id));
            setLoading(false);
        } else {
            if (schoolList.length > 0) {
                if (idExists(schoolList, school_id)) {
                    setSchool(school_id);
                    const Id = async () => {
                        const res = await getDeviceId(schoolList[school_id - 1].place_id, authToken);
                        if (res && res.sems_device_id) {
                            const value = localStorage.getItem('schools');
                            const schools = value ? JSON.parse(value) : [];
                            const schoolObj = { id: school_id, device_id: res.sems_device_id };
                            schools.push(schoolObj);
                            localStorage.setItem('schools', JSON.stringify(schools));
                            setDeviceId(res.sems_device_id)
                        }
                        setLoading(false);
                    }
                    Id();
                } else {
                    history.push('/home')
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authToken, schoolList, school_id])

    useEffect(() => {
        if (deviceId !== null) {
            setLoading(true);
            const controller = new AbortController();
            const signal = controller.signal;
            const deviceData = async (signal) => {
                const res = await getDeviceConfig(authToken, deviceId, { configType: 'network_config' }, signal);
                setpcsData(res);
                setLoading(false);
            }
            const interval = setInterval(() => {
                deviceData(signal);
            }, 60000);

            deviceData(signal);
            return () => {
                clearInterval(interval);
                controller.abort();
            };
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [deviceId])


    return (
        <>
            {loading ? <Spinner /> : <section>
                <Col>
                    <Row className="mx-3">
                        {/* <select className="btn__select">
                                <option disabled selected>ソート</option>
                                <option>装置名</option>
                                <option>BT-PCS </option>
                                <option>PV-PCS</option>
                                <option>デバイスエラー</option>
                            </select> */}
                        <span className="text_graph mx-auto">デバイス情報</span>
                        {/* <div className="searchBar">
                                <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" className="ml-3 mb-2">
                                    <circle cx="13.75" cy="13.75" r="8.75" stroke="#233C6B" stroke-width="2" />
                                    <path d="M13.75 10C13.2575 10 12.7699 10.097 12.3149 10.2855C11.86 10.4739 11.4466 10.7501 11.0983 11.0983C10.7501 11.4466 10.4739 11.86 10.2855 12.3149C10.097 12.7699 10 13.2575 10 13.75" stroke="#233C6B" stroke-width="2" stroke-linecap="round" />
                                    <path d="M25 25L21.25 21.25" stroke="#233C6B" stroke-width="2" stroke-linecap="round" />
                                </svg>
                                <span className="text_graph ml-4">|  <input type="text" placeholder="デバイスを表示" className="text_search" /></span>
                            </div> */}

                    </Row>
                    <Row className="mt-4 device-container">
                        <Col md={12}>
                            <div className="remote__table device__table"><Table className="device_data">
                                <thead>
                                    <th>状態</th>
                                    <th>デバイス名</th>
                                    <th>製品名</th>
                                    <th>現在の太陽光発電電力<br />[kW]</th>
                                    <th>現在のSOC<br />[%]</th>
                                    <th>エラー</th>
                                </thead>
                                <tbody>
                                    {pcsData.map((value, index) => {
                                        return (
                                            <tr>

                                                <td className="hovertext" data-hover={`${value.event_type.includes("E") || (value.event_type.includes("E") && value.event_type.includes("W")) ? "エラー" : value.event_type.includes("W") ? "警告" : value.event_type.includes("C") ? "通信エラー" : "正常"}`}>{
                                                    value.work_status !== null && (value.event_type.length === 0 || value.event_type.includes("G")) ?
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="green" className="bi bi-check-circle" viewBox="0 0 16 16">
                                                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                                            <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z" />
                                                        </svg>
                                                        : value.work_status !== null && (value.event_type.includes("E") || (value.event_type.includes("E") && value.event_type.includes("W"))) ?
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="red" className="bi bi-x-circle" viewBox="0 0 16 16">
                                                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                                                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                                                            </svg>
                                                            : value.work_status === null || value.event_type.includes("C") ?
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-exclamation-circle" viewBox="0 0 16 16">
                                                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                                                    <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z" />
                                                                </svg>
                                                                : value.work_status !== null && value.event_type.includes("W") ?
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#ffba00" className="bi bi-exclamation-triangle" viewBox="0 0 16 16">
                                                                        <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z" />
                                                                        <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z" />
                                                                    </svg>
                                                                    : ''
                                                }
                                                </td>
                                                <td>{value.device_id}</td>
                                                <td>{value.device_model_no}</td>
                                                {value.device_id === "MMR" || value.device_id === "WMR" ? <><td>---</td><td>---</td></> :
                                                    <>

                                                        {value.device_id.includes('BTPCS') ? <td>---</td> : <td>{value.hasOwnProperty('real_power') ? value.real_power !== null ? formatValue(value.real_power) : "---" : "---"}</td>}
                                                        {value.device_id.includes('PVPCS') ? <td>---</td> : <td>{value.hasOwnProperty('soc') ? value.soc !== null ? value.soc : "---" : "---"}</td>}
                                                    </>
                                                }
                                                <td>{value.hasOwnProperty('message') ? value.message && value.message !== null ? value.message : "---" : "---"}</td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </Table></div>
                        </Col>
                    </Row>
                </Col>
            </section>}
        </>
    );
}

export default Devicepage;